import { FormFieldTypes } from "../../../data/formFieldType";

export const GMPCourseFormData = {
  name: "GMPCourseFormData",
  initialState: {
    organisationName: "",
    uENNumber: "",
    startDate: null,
    endDate: null,
    statusId:0
  },
  formFields: [
    {
      id: "uENNumber",
      lable: "Search by Organisation UEN",
      Field_Name: "Search by Organisation UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "uENNumber",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-6 mb-2",
      },
    },
    {
      id: "organisationName",
      lable: "Search by Organisation Name/Event Name",
      Field_Name: "Search by Organisation Name/Event Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "organisationName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-6 mb-2",
      },
    },
    {
      id: "startDate",
      lable: "Submitted Date From",
      Field_Name: "Submitted Date From",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "startDate",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-3 mb-2",
      },
    },

    {
      id: "endDate",
      lable: "Submitted Date To",
      Field_Name: "Submitted Date To",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "endDate",
      fieldSetting: {
        placeholder: "Select",
      },
      style: {
        containerCss: "col-lg-3 mb-2",
      },
    },
    {
      id: "statusId",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
          placeholder: "",
          options: []
      },
      style: {
          containerCss: "col-lg-3 mb-2"
      }
  },
  {
    id: "sourceId",
    lable: "Source",
    Field_Name: "Source",
    fieldType: FormFieldTypes.SELECT,
    dataField: "sourceId",
    fieldSetting: {
        placeholder: "",
        options: []
    },
    style: {
        containerCss: "col-lg-3 mb-2"
    }
},

  ],
  formSetting: {
    isViewOnly: false,
  },
};